export default __webpack_public_path__ + "static/media/coding-dash.69f5032f.svg";